import React from 'react';
import { useTranslation } from 'react-i18next';
import QuranLoading from '../app/quran/QuranLoading';

/**
 * RouteLoadingFallback
 * Lightweight, aesthetic loading indicator for route transitions.
 * Adapts to theme and language direction without jarring layout shifts or half-screen cutoffs.
 */
export default function RouteLoadingFallback({ message }) {
  const { i18n } = useTranslation();
  const isAr = i18n.language ? i18n.language.startsWith('ar') : true;

  const isQuranRoute = typeof window !== 'undefined' && (
    window.location.pathname.startsWith('/quran') || window.location.pathname.includes('/app/quran')
  );

  if (isQuranRoute) {
    return (
      <div className="fixed inset-0 z-50 flex min-h-screen h-screen w-full flex-col items-center justify-center p-6 bg-white dark:bg-[#171614] select-none">
        <QuranLoading layout="lesson" isAr={isAr} message={message} />
      </div>
    );
  }

  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-screen w-full flex-col items-center justify-center p-6 text-slate-800 dark:text-slate-100"
      dir={isAr ? 'rtl' : 'ltr'}
    >
      <div className="relative flex h-14 w-14 items-center justify-center">
        {/* Track */}
        <div className="absolute inset-0 rounded-full border-2 border-primary-accent/15 dark:border-white/10" />
        {/* Spinner */}
        <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-primary-accent border-r-sky-400 animate-spin" />
        {/* Inner dot */}
        <div className="h-2 w-2 rounded-full bg-primary-accent animate-pulse" />
      </div>

      <span className="mt-4 text-xs font-semibold tracking-wide text-slate-500 dark:text-slate-400">
        {message || (isAr ? 'جاري التحميل...' : 'Loading...')}
      </span>
    </div>
  );
}
